import React, { PureComponent } from 'react';
import Fuse from 'fuse.js';
import pick from 'lodash/pick';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import { replaceSpaceDash } from '../../../helpers/stringutils';
import Month from './components/months';
import PopularityDropdown from './components/popularityDropdown';
import TravelStyle from './components/travelstyle';
import Continents from './components/continents';
import Filterbar from './filterbar';

class Searchbar extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      originalSearchList:props.searchResults,
      categoriesNames:[],
      categoriesIndex:[],
      searchInputValue:"",
      searchReady:false,
      isSearchOpen:false,
      searchDropdownNumber:-1,
      isOptionsOpen:false
    }

    this.searchInput = null;
    this.searchResults = null;
    this.searchIcon = null;
    this.fuse = null;

    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.documentKeydownHandler = this.documentKeydownHandler.bind(this);

    this.optionsClick = this.optionsClick.bind(this);
    // this.optionsApplyClick = this.optionsApplyClick.bind(this);
  }

  documentKeydownHandler(e){

    const { isSearchOpen, searchDropdownNumber } = this.state;
    const searchInput = document.querySelectorAll('.search-results-wrapper .search-results ul li');
    const searchActive = document.querySelector('.search-results-wrapper .search-results ul li[data-index="'+searchDropdownNumber+'"] span');

    if(isSearchOpen){

      //Increment/Decrement cursor position
      if(e.key === 'ArrowDown' && searchDropdownNumber < searchInput.length - 1){
        this.setState({searchDropdownNumber:searchDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && searchDropdownNumber > 0){
        this.setState({searchDropdownNumber:searchDropdownNumber - 1});
      }
      else if(e.key === 'Enter'){

        if(searchActive !== null){
          this.searchItemClick(null, {
              url:searchActive.dataset.url,
              name:searchActive.dataset.name,
              category:searchActive.dataset.category
          });
        }

      }
    }
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
    document.body.removeEventListener('ON_FILTER_RESET', this.searchClear );
    document.body.removeEventListener('ON_CONTINENT_CLICK', this.searchInputToggle );
    document.body.removeEventListener('ON_TRAVELSTYLE_CLICK',  this.searchInputToggle );
    document.body.removeEventListener('ON_COUNTRY_CLICK', this.searchInputToggle );
    this.fuse = null;
  }

  documentClickHandler(e){

   try{
    if(e.target.offsetParent.className !== "search-bar" ||
       e.target.offsetParent.className !== "search-results active" ||
       e.target.offsetParent.className !== "search-results" ||
       e.target.offsetParent.className !== "search-results-wrapper" ||
       e.target.offsetParent.className !== "options-menu"){
        if(this.state.isSearchOpen){
          setTimeout(() => this.searchResultsToggle("close"), 50);
        }
        if(this.state.isOptionsOpen){
          this.setState({isOptionsOpen:false})
        }
    }
    }catch(e){}
  }

  componentDidMount(){

    const { originalSearchList } = this.state;


    //save input data fields
    this.searchInput = document.querySelector('#search-input');
    this.searchResults = document.querySelector('.search-results');
    this.searchIcon = document.querySelector('.search-icon');

    //get duplicate categories index
     let categoriesIndexTemp = [];
     originalSearchList.forEach((item, index) => {
        categoriesIndexTemp[item.category] = categoriesIndexTemp[item.category] || [];
        categoriesIndexTemp[item.category].push(index);

        if(index === originalSearchList.length - 1){
          this.setState({categoriesIndex:categoriesIndexTemp})
        }
     });


     //initialise fuse fuzzy search
     this.fuse = new Fuse(originalSearchList, {
       shouldSort: true,
       tokenize: true,
       matchAllTokens: true,
       findAllMatches: true,
       threshold: 0.3,
       location: 0,
       distance: 10,
       maxPatternLength: 32,
       minMatchCharLength: 3,
       keys: ["name", "category", "tags.startCity", "tags.endCity"]
    });


    //1. filter search categories and remove duplicates
    //2. Search ready
    this.setState({
      categoriesNames:uniq(map(originalSearchList, (pick, 'category'))),
      searchReady:true
    });

    //listeners
    document.body.addEventListener('click', this.documentClickHandler);
    document.body.addEventListener('ON_FILTER_RESET', e => this.searchClear() );
    document.body.addEventListener('ON_CONTINENT_CLICK', e => this.searchInputToggle(e.detail) );
    document.body.addEventListener('ON_TRAVELSTYLE_CLICK', e => this.searchInputToggle(e.detail) );
    document.body.addEventListener('ON_COUNTRY_CLICK', e => this.searchInputToggle(e.detail) );

  }

  componentDidUpdate(prevProp, prevState){

    const { searchDropdownNumber } = this.state;

    if(searchDropdownNumber !== prevState.searchDropdownNumber){

      const searchInputContainer = document.querySelector('.search-results-wrapper .search-results');
      const searchInput = document.querySelectorAll('.search-results-wrapper .search-results ul li');

      for(let i = 0; i < searchInput.length; i++){
        searchInput[i].classList.remove('hover');
      }

      if(searchInput[searchDropdownNumber].dataset.index !== undefined){

        //hover state
        searchInput[searchDropdownNumber].classList.add('hover');

        //scroll container
        searchInputContainer.scrollTop = searchInput[searchDropdownNumber].offsetTop;

      }

     }
  }

  toggleIcon(iconType){
    const searchSVG = this.searchIcon.querySelector('.search-svg');
    const closeSVG = this.searchIcon.querySelector('.close-svg');

    if(iconType === 'close'){
      searchSVG.style.display = "none";
      closeSVG.style.display = "block";
    }else{
      searchSVG.style.display = "block";
     closeSVG.style.display = "none";
    }

  }

  renderSearchResultItems(arr, pattern){

    const { categoriesNames, categoriesIndex } = this.state;
    let searchResultItems = [];
    let searchResultItemsPattern = [];


      //create original search list
      for (let i = 0; i < arr.length; i++){
        searchResultItems.push(
          <li key={ `${arr[i].name}${Math.random()}` } data-index={i}>
            <span
              data-url={arr[i].weburl}
              data-name={arr[i].name}
              data-category={arr[i].category}
              target="_blank"
              onClick={ e => this.searchItemClick(e) }>
                {arr[i].list_name}
              </span>
          </li>
        )

        //modify search list with categories
        if(i === arr.length - 1){

          //copy array search pattern
          searchResultItemsPattern = searchResultItems.slice(0);

          for(let j = 0; j < categoriesNames.length; j++){
            let categoriesOrderIndex = categoriesIndex[categoriesNames[j]][0];
            let titleli = <li key={ `${categoriesNames[j]}${Math.random()}` } className={`title ${replaceSpaceDash(categoriesNames[j])}`}>{categoriesNames[j]}</li>
            searchResultItems.splice(categoriesOrderIndex + j, 0, titleli);
          }
        }
      }
      return (pattern === "") ? searchResultItems : searchResultItemsPattern;
  }

  search(pattern){
      const { searchReady, originalSearchList } = this.state;

      if(searchReady){
        const _searchPattern = (pattern === "") ? originalSearchList : this.fuse.search(pattern);
        return <ul id="search-result-list">{this.renderSearchResultItems(_searchPattern, pattern)}</ul>
      }else{
        return <p>Loading...</p>
      }
  }

  searchItemClick(e, itemObj ){

    var target = (e !== null) ? e.target.dataset : itemObj;

    if(target.url === ""){

      this.searchInputToggle(target.name);

      switch (target.category) {
        case "Destination":
          this.props.searchResultContinentOnSelect(target.name);
          break;
       case "Travel Styles":
          this.props.searchResultTravelStyleOnSelect(target.name);
         break;
      case "Country":
          this.props.searchResultCountryOnSelect(target.name);
        break;
      //case "Style":
          //window.location.href = `${BusaboutDiscovery.WWW_DISCOVERY_URL}${BusaboutDiscovery.DISCOVER_PAGE}`;
        //break;
        default:
      }
    }else{
        window.location.replace(target.url);
    }

    if(e == null) this.searchResultsToggle("close");

  }

  searchInputToggle(name){
    this.setState({ searchInputValue:name});
    this.searchInput.classList.add('active');
    this.toggleIcon('close');
  }

  searchResultsToggle(state){
      switch(state){
        case "toggle":
          if(this.searchIcon.classList !== null) this.searchIcon.classList.toggle('active');
          if(this.searchResults !== null) this.searchResults.classList.toggle('active');
          if(this.state.isSearchOpen){
            this.setState({isSearchOpen:true});
          }else{
            this.setState({isSearchOpen:false});
          }
        break;

        case "open":
          if(this.searchIcon.classList !== null) this.searchIcon.classList.add('active');
          if(this.searchResults !== null) this.searchResults.classList.add('active');
          this.setState({isSearchOpen:true});
          // this.props.mobileFilterSelect();
        break;

        case "close":
          if(this.searchIcon.classList !== null) this.searchIcon.classList.remove('active');
          if(this.searchResults !== null) this.searchResults.classList.remove('active');
          this.setState({isSearchOpen:false});
        break;

        default:
      }
    }

  searchHandleChange(e){
    this.setState({searchInputValue:e.target.value});
    this.search(e.target.value);
  }

  searchClear(){

    if(this.searchInput !== null && this.searchInput.className === 'active'){
      this.toggleIcon('search');
      this.setState({ searchInputValue:''});
      this.searchInput.classList.remove('active');
      this.props.onSelect();
    }
  }

  optionsClick(){
    this.setState({isOptionsOpen: !this.state.isOptionsOpen});
  }


  render(){

    const { searchInputValue, isOptionsOpen } = this.state;

    return (
      <div className="search-bar-wrapper">
          <div className="search-bar">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="search-icon" onClick={e => this.searchClear()}>
              <path className="search-svg" d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"/>
              <path className="close-svg" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"/>
            </svg>

            <input autoComplete="off" type="search" id="search-input" value={searchInputValue} placeholder="Search for trip" onClick={ e => this.searchResultsToggle("open")} onChange={ e => this.searchHandleChange(e) } onKeyDown={e => this.documentKeydownHandler(e)} />

            <button type="button" className={`search-bar-options ${isOptionsOpen ? 'active' : ''}`} onClick={this.optionsClick}>
              <span>Options</span>

              <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 16' className="filter-icon">
                  <defs />
                  <g transform='translate(-73.5 -253.5)'>
                      <line className='filter-icon-line' x2='32' transform='translate(73.5 254.5)' />
                      <line className='filter-icon-line' x2='24' transform='translate(77.5 261.5)' />
                      <line className='filter-icon-line' x2='16' transform='translate(81.5 268.5)' />
                  </g>
              </svg>

            </button>
          </div>


          <div className="search-results-wrapper">

            <div className="search-results">
              { this.search(searchInputValue) }
            </div>

            <div className="options-menu" style={{'display': isOptionsOpen ? 'block' : 'none'}} >

              <div className="row">
                <div className="columns small-12 medium-8 large-6 large-offset-1">
                  <Month type={"no-collapse"} onSelect={this.props.onMonthSelect} departureDates={this.props.departureDates} months={this.props.months} nextYearMonths={this.props.nextYearMonths} />
                </div>
                <div className="columns small-12 medium-4 large-5">
                  <PopularityDropdown type={"no-collapse"} onDropDown={this.props.onDropDown} activeDropDown={this.props.activeDropDown}/>
                </div>
              </div>

              <div className="row">
                <div className="columns small-12 medium-9 medium-offset-1 ">
                  <hr/>
                </div>
              </div>

              <div className="row">
                <div className="columns small-12 medium-8 large-6 large-offset-1">
                  <TravelStyle type={"no-collapse"} active={this.props.active} onSelect={this.props.onTravelStyleSelect} data={this.props.travelStyleData} />
                </div>
                <div className="columns small-12 medium-4 large-5">
                  <Continents type={"no-collapse"} active={this.props.active} onSelect={this.props.onContinentSelect} data={this.props.continentData}/>
                </div>
              </div>

              {/* <div className="row">
                <div className="columns small-12">
                  <button type="button" onClick={this.optionsApplyClick}>
                    <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.613 0h-.323a.387.387 0 0 0-.387.387v3.569A8 8 0 0 0 .01 7.596C0 7.817.177 8 .397 8H.72c.205 0 .376-.16.386-.364a6.903 6.903 0 0 1 13.032-2.797h-3.686a.387.387 0 0 0-.387.387v.322c0 .214.173.387.387.387h5.16A.387.387 0 0 0 16 5.548V.388A.387.387 0 0 0 15.613 0zm-.01 8h-.323a.386.386 0 0 0-.386.364A6.902 6.902 0 0 1 8 14.904a6.906 6.906 0 0 1-6.139-3.743h3.687a.387.387 0 0 0 .387-.387v-.322a.387.387 0 0 0-.387-.387H.388a.387.387 0 0 0-.388.387v5.16c0 .215.173.388.387.388H.71a.387.387 0 0 0 .387-.387v-3.569a8 8 0 0 0 14.893-3.64.386.386 0 0 0-.387-.404z" fill="#FFF" fillRule="nonzero"/>
                    </svg>
                    Apply Options
                  </button>
                </div>
              </div> */}

            </div>

          </div>

          <Filterbar active={this.props.active} onSelect={this.props.onSelect} />

      </div>
    )
  }
}



export default Searchbar;



// WEBPACK FOOTER //
// ./src/components/tripSearch/filters/searchbar.js